import { gql } from '@apollo/client';
import { SearchFilter } from 'types/Filters';

const listOrganizations = (filter: SearchFilter) => {
    return {
        variables: { filter },
        query: gql`
            query ListOrg($filter: OrganizationFilter) {
                listOrganizations(filter: $filter) {
                    count
                    pages
                    pageSize
                    page
                    nodes {
                        organizationUri
                        label
                        created
                        updated
                        description
                        owner
                        SamlGroupName
                        tags
                        stats {
                            environments
                        }
                    }
                }
            }
        `,
    };
};

export default listOrganizations;
